import cx from 'clsx'
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface IParagraphProps
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  > {
  color?: 'black' | 'white' | 'gradient' | 'red' | 'grey'
  weight?: 'normal' | 'medium' | 'bold'
  opacity?: number
  size?: 'h1' | 'h2' | 'h3' | 'big' | 'small'
}

const Paragraph = ({
  color = 'black',
  opacity = 1,
  size = 'big',
  weight = 'normal',
  style,
  className,
  children,
  ...rest
}: IParagraphProps) => {
  const classes = cx(cn.paragraph, cn[color], cn[weight], cn[size], className)
  return (
    <p {...rest} className={classes} style={{ opacity, ...style }}>
      {children}
    </p>
  )
}

export default Paragraph
